import axios from "axios";
import { useAccount, useMsal } from "@azure/msal-react";
import { msalScopes } from "../auth/AuthConfig";
 
 
export const useAuthAxiosRequest = () => {
  const { instance, accounts } = useMsal();
 
  const account = useAccount(accounts[0] || {});
 
  const getAccessToken = async () => {
    if (!account) return null;
 
    try {
      const { accessToken } = await instance.acquireTokenSilent({
        ...msalScopes,
        account,
      });
      return accessToken;
    } catch (err) {
      // Only fallback to popup if interaction is required
        try {
          const { accessToken } = await instance.acquireTokenPopup({
            ...msalScopes,
            account,
          });
          return accessToken;
        } catch (popupError) {
          console.error("Popup token acquisition failed.", popupError);
          return null;
        }
      }
   
  };
 
  const authAxiosRequest = async (endpoint, config = {}) => {
    const accessToken = await getAccessToken();
 
    const updatedConfig = {
      ...config,
 
      headers: {
        ...config.headers,
 
        ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
      },
    };
 
    return axios({
      url: endpoint,
 
      baseURL: process.env.REACT_APP_BACKEND_URI,
 
      ...updatedConfig,
    });
  };
 
  return { authAxiosRequest };
};
 